import { NgModule } from '@angular/core';
import { FooterComponent } from '../../layouts/panelLayout/footer/footer.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NewFooterComponent } from '../../layouts/panelLayout/new-footer/new-footer.component';


@NgModule({
  declarations: [
    FooterComponent,
    NewFooterComponent
  ],
  imports: [
    RouterModule,
    TranslateModule.forChild({}),
    CommonModule
  ],
  exports: [
    TranslateModule,
    FooterComponent,
    NewFooterComponent,
    RouterModule
  ]
})
export class AppSharedModule { }
